import React from 'react';
import BottomSection from '../components/BottomSection';
import careersHero from '../assets/images/careers-hero.png';
import { useSeo } from '../seo';

function CareersPage() {
  useSeo('careers');

  return (
    <main className="join-us-page">
      <section className="join-us-section">
        <img className="join-us-image" src={careersHero} alt="价探加入我们页面头图" />
      </section>

      <section className="join-us-section careers-title-section">
        <div className="careers-title-block">
          <div className="careers-title-copy">
            <div className="careers-title-line">
              <span className="careers-title-label">招聘邮箱：</span>
              <span className="careers-title-value">hr@jiatanpricetag.com</span>
            </div>
          </div>
        </div>
      </section>

      <BottomSection />
    </main>
  );
}

export default CareersPage;
